var _excluded = ["autotagging-flora", "data-flora-text", "data-autotagging-flora-section", "aria-label", "as", "children", "disabled", "has", "isLoading", "hierarchy", "icon", "isFull", "isUppercase", "styleSemantic", "size", "surfaceColor"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { forwardRef } from '@grupoboticario/flora-react-system';
import { Spinner } from '@grupoboticario/flora-react-spinner';
import { StyledButton, ButtonIcon } from './styles';
/**
 * @component
 * @name FloraButton
 * @description Elemento interativo para realizar ações em aplicativos e sites. Ele pode conter texto, ícones ou ambos, variar em estilo e aparência, oferecer feedback visual quando pressionado e desempenha um papel crucial na usabilidade, fornecendo uma maneira intuitiva e consistente para os usuários executarem ações específicas, como enviar formulários, salvar alterações ou navegar para outras páginas. Além disso, os botões devem ser projetados com acessibilidade em mente, para garantir que todos os usuários possam interagir com eles de forma eficaz.
 * @tutorial https://florabook.gb.tech/v2/index.html?path=/docs/core-components-florabutton
 */

export var FloraButton = forwardRef((_ref, forwardedRef) => {
  var {
    'autotagging-flora': autotaggingFlora = 'off',
    'data-flora-text': dataFloraText,
    'data-autotagging-flora-section': dataAutotaggingFloraSection = '',
    'aria-label': ariaLabel,
    as = 'button',
    children,
    disabled = false,
    has = 'iconRight',
    isLoading = false,
    hierarchy = 'primary',
    icon,
    isFull = false,
    isUppercase = false,
    styleSemantic = 'neutral',
    size = 'medium',
    surfaceColor = 'light'
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledButton, _extends({}, props, {
    ref: forwardedRef,
    as: as,
    "aria-label": ariaLabel,
    "aria-busy": isLoading,
    "autotagging-flora": autotaggingFlora,
    "data-flora-text": dataFloraText || ariaLabel || typeof children === 'string' && children,
    "data-autotagging-flora-section": dataAutotaggingFloraSection,
    "data-flora": "button",
    disabled: disabled,
    styleSemantic: styleSemantic,
    size: size,
    surfaceColor: surfaceColor,
    hierarchy: hierarchy,
    hasIconOnly: has === 'iconOnly',
    hasIcon: !!icon,
    has: has,
    isFull: isFull,
    isUppercase: isUppercase,
    isLoading: isLoading
  }), has !== 'iconOnly' && /*#__PURE__*/React.createElement("span", {
    className: "button-label"
  }, children), (icon || isLoading) && /*#__PURE__*/React.createElement(ButtonIcon, {
    "data-testid": "button-" + has,
    "aria-hidden": "true",
    className: "button-icon"
  }, isLoading ? /*#__PURE__*/React.createElement(Spinner, null) : icon));
});
//# sourceMappingURL=FloraButton.js.map